export default __webpack_public_path__ + "assets/images/a8ac527b6c16652a934e2a3edef51916.svg";